/*
 * ProfanityLexiconSignals — what a person's own censoring says about the
 * shared dictionary.
 *
 * Chat 640 (09.10.2026): a paying user kept 14 words in her OWN black list —
 * въебали, выблядки, отпизженных, ебнулся… — every one a gap in the shared
 * lexicon, and none of them ever reached us: the «Предложить слова в общий
 * словарь» form had collected three submissions in two months. People fix a
 * miss where they see it — in their list, or by clicking the word in the
 * transcript — and move on. Those acts are the signal; this module decides
 * which of them may leave the page.
 *
 *   gap(token, lang, base)      — a word the person censors that the shared
 *                                 dictionary (`base`: all tiers, no personal
 *                                 lists) does not catch. Reported ONLY when it
 *                                 carries an obscene root: a personal list also
 *                                 holds names, nicknames and brands, and those
 *                                 stay on the page.
 *   falseHit(token, lang, base) — a word the dictionary catches that the person
 *                                 un-censors or puts in the white list.
 *   seen(tokens, lang, base)    — which dictionary words were flagged in this
 *                                 recording at all. A removal means something
 *                                 only against the people the word was MET by:
 *                                 «блядь» is met by hundreds and un-censored by
 *                                 a few — their choice; an ordinary word caught
 *                                 by mistake is un-censored by nearly everyone
 *                                 who sees it flagged. The first weekly mail
 *                                 (12.10.2026) listed twelve «false hits», every
 *                                 one a real swear word.
 *
 * Nothing here adds a word to the dictionary: candidates are counted across
 * distinct people by `php artisan profanity:lexicon-harvest`, and a human
 * edits profanity-lexicons.js (an accepted crowd word is a vandalism vector —
 * tool_profanity_word_suggestions_2026_08_07).
 */
(function (root) {
    'use strict';

    // «еб» only at the start or after a vowel / ъ / ь (поебень, въеб, уеб):
    // after a consonant it is Глеб, хлеб, небо, себя.
    var CYR = /(?:^|[аеиоуыэюяъь])еб|ху[йиеяю]|пи[зс][дж]|пезд|бля[дтжб]|муда[кч]|мудил|залуп|дроч|г[ао]ндон|пид[оа]?р|шлюх|ублюд/;
    var GAP_ROOTS = {
        ru: CYR,
        uk: CYR,
        en: /fuck|shit|cunt|bitch|dick|cock|puss|whore|slut|nigg|fag|wank|twat|bastard/
    };
    var MAX_LEN = 32;

    // the dictionary's own normalization (ё→е, leet, stretched letters) — the
    // same form its rules and the harvest see
    function normalize(token, lang, base) {
        var s = String(token || '').replace(/\*+\s*$/, '');      // a list entry «слово*» is a prefix
        if (base && base.normalizeToken) return base.normalizeToken(s);
        var D = typeof root !== 'undefined' && root.ProfanityDetector;
        return D && D._normalizeToken ? D._normalizeToken(s, lang) : s.toLowerCase().replace(/ё/g, 'е');
    }

    function gap(token, lang, base) {
        var re = GAP_ROOTS[lang];
        if (!re) return null;
        var n = normalize(token, lang, base);
        if (!n || n.length < 3 || n.length > MAX_LEN || /\d/.test(n)) return null;
        if (!re.test(n)) return null;
        if (!base || base.scanToken(n)) return null;            // the dictionary already has it
        return n;
    }

    function falseHit(token, lang, base) {
        var n = normalize(token, lang, base);
        if (!n || n.length > MAX_LEN || !base) return null;
        var r = base.scanToken(n);
        if (!r || r.kind === 'custom') return null;
        return { w: n, rule: r.ruleId || '' };
    }

    /* tokens — the texts of the words the dictionary flagged (repeats welcome).
     * Returns { n, w }: n distinct forms; w — up to MAX_SEEN of them, the most
     * frequent first, space-separated. A form longer than SEEN_LEN letters is the
     * recogniser's glue of several words («хуйминиминиманимо») — it carries a
     * neighbour's speech and stays on the page. */
    var MAX_SEEN = 60, SEEN_LEN = 20;
    function seen(tokens, lang, base) {
        var count = {}, order = [];
        for (var i = 0; i < (tokens || []).length; i++) {
            var r = falseHit(tokens[i], lang, base);
            if (!r || r.w.length > SEEN_LEN) continue;
            if (!count[r.w]) { count[r.w] = 0; order.push(r.w); }
            count[r.w]++;
        }
        order.sort(function (a, b) { return count[b] - count[a] || (a < b ? -1 : a > b ? 1 : 0); });
        return { n: order.length, w: order.slice(0, MAX_SEEN).join(' ') };
    }

    var api = { gap: gap, falseHit: falseHit, seen: seen, GAP_ROOTS: GAP_ROOTS };
    if (typeof module !== 'undefined' && module.exports) module.exports = api;
    if (typeof root !== 'undefined') root.ProfanityLexiconSignals = api;
})(typeof self !== 'undefined' ? self : this);
